import React, { useEffect, useRef, useState } from 'react';
import { getAttributes } from '../utils';
import { css, cx } from 'emotion';
import { useContent, Content } from '../../brite-viewer-v2/ContentProvider';
import { Box } from '../../../shared-components/Box';
import { Link } from 'phosphor-react';
import { Text } from '../../../shared-components';
import { container } from '../../../shared-components/shared-styles';
import { QR } from '../../../shared-components/QR';
import { colors } from '../../../shared-components/styles';

export const TextV2 = ({ item, totalColumns }) => {
  const content = useContent();
  const mediaType = Content.getViewMode(content);

  const componentAttributes = getAttributes({
    column: item,
    length: totalColumns,
    type: 'component',
  });

  const combineComponentClass = cx(
    componentAttributes.className,
    css`
      ol,
      ul,
      p {
        margin: 0;
        li {
          margin: 0;
        }
      }
    `
  );

  const props = {
    ...componentAttributes,
    className: combineComponentClass,
    content: item?.content,
  };

  switch (mediaType) {
    case 'pdf': {
      return <PrintText {...props} />;
    }
    default: {
      return <pre {...props} dangerouslySetInnerHTML={{ __html: item?.content }}></pre>;
    }
  }
};

const PrintText = (props) => {
  const preRef = useRef();
  const [links, setLinks] = useState([]);

  function extractLinks() {
    const links = [];
    const anchors = preRef.current.querySelectorAll('a');
    anchors.forEach((a) => {
      if (a.href) {
        links.push({
          left: preRef.current.offsetLeft + a.offsetLeft + a.offsetWidth,
          top: preRef.current.offsetTop + a.offsetTop,
          label: a.innerText,
          url: a.href,
        });
      }
    });
    setLinks(links);
  }

  useEffect(() => {
    extractLinks();
  }, []);

  return (
    <>
      <Box
        css={`
          position: relative;
          width: 100%;
          height: auto;
        `}
      >
        <pre {...props} ref={preRef} dangerouslySetInnerHTML={{ __html: props?.content }}></pre>

        {links?.length ? (
          <>
            {links.map((link, index) => (
              <span
                className={css`
                  position: absolute;
                  left: calc(${link.left}px);
                  top: ${link.top}px;
                  font-size: 0.8em;
                  color: var(--text-body);
                `}
              >
                {index + 1}
              </span>
            ))}
            <Box
              css={`
                ${container.box}
                padding: 8px;
                padding-left: 16px;
                gap: 16px;
                margin: 8px 0;
              `}
              flex="space-between"
            >
              <Box
                flex="left"
                css={`
                  gap: 16px;
                `}
              >
                <Link size={32} color="var(--button-background-color)" />
                <Text h4>Links</Text>
              </Box>
              <Box>
                <Box
                  flex="right wrap"
                  css={`
                    gap: 16px;
                  `}
                >
                  {links.map((link, index) => (
                    <Box
                      flex="space-between"
                      key={link.url + index}
                      css={`
                        border-radius: 8px;
                        background-color: ${colors.gray[600]};
                      `}
                    >
                      <Text
                        label
                        bold
                        css={`
                          padding-left: 8px;
                          color: white;
                        `}
                      >
                        {index + 1}
                      </Text>
                      <Box>
                        <QR width={80} height={80} data={link.url} />
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </>
        ) : null}
      </Box>
    </>
  );
};
